<div class="subscribe-container" [style.backgroundColor]="backgroundColor" [style.height]="height">
    <div class="margin-top-xl">
        <p>Vous avez atteint la limite des ressources consultables gratuitement dans le cadre de votre test.</p>
        <p>Pour vous abonner et accéder à l’ensemble des ressources publiées chaque mois par We talk, <a (click)="buy()" class="contact-link">cliquez ici</a></p>
    </div>
    <div>
        <img class="subscribe-image" src="assets/images/transaction.png" alt="Transaction image">
    </div>
</div>